import { Action, ActionFn, defaultActions } from '#/common/components/DataGrid';
import { Tenant } from '#/graphql/types';

export const selectedActions: ActionFn<Tenant>[] = [
  {
    key: 'delete-tenants',
    icon: 'trash',
    text: 'Delete',
  },
];

export const actions: Action<Tenant>[] = [...defaultActions];
